<template>
    <div class="day" :style="`height: ${CONFIG.timeline.dayHeight}px`"></div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "TimelineDay",
    data: () => ({ CONFIG })
};
</script>